// extracted by mini-css-extract-plugin
export var columnItem = "_bv-3";
export var columnItemDraggable = "_bv-5";
export var dragHandle = "_bv-0";
export var dragHandleHovered = "_bv-1";
export var dropdown = "_bv-6";
export var dropdownContent = "_bv-8";
export var dropdownInner = "_bv-7";
export var filterDropdownHeader = "_bv-9";
export var icon = "_bv-2";
export var moveToTopButton = "_bv-4";
export var sectionDivider = "_bv-a";